import { storageBackendErrorText } from "@/components/dataset/storageBackendText";
import { isHttpClientError } from "@/http";

// 제외된 에피소드의 재검사 거절(409 `episode.excluded`) 문구다. 재검사 버튼의 꺼진 이유도 이 문구다.
export const EXCLUDED_EPISODE_RECHECK_TEXT =
  "제외된 에피소드는 재검사할 수 없습니다. 리뷰에서 먼저 복원해 주세요.";

const operationErrors: Readonly<Record<string, string>> = {
  "worker.scaling.in_progress":
    "Worker 수를 변경하고 있습니다. 변경이 끝난 뒤 설정을 저장해 주세요.",
  "worker.scaling.revision_conflict":
    "다른 관리자가 설정을 변경했습니다. 최신 설정을 확인해 주세요.",
  "upload.not_found": "업로드 잡을 찾을 수 없습니다.",
  "diagnostic_job.not_found": "진단 잡을 찾을 수 없습니다.",
  "diagnostic_job_window.not_found":
    "구간을 찾을 수 없습니다. 작업을 다시 시작하면 구간이 새로 만들어집니다. 구간 목록을 새로 확인해 주세요.",
  "diagnostic_job.not_cancellable": "현재 상태에서는 중단할 수 없습니다.",
  "diagnostic_job.not_resumable": "현재 상태에서는 이어서 실행할 수 없습니다.",
  "episode.not_found": "에피소드를 찾을 수 없습니다.",
  "episode.not_invalid": "이미 invalid가 해제되었습니다. 최신 목록을 확인해 주세요.",
  "episode.excluded": EXCLUDED_EPISODE_RECHECK_TEXT,
};

// 서버가 락 안에서 재검증한 운영 오류를 설명한다. 상태 전이의 허용 여부는 서버가 소유한다.
export function adminOperationError(error: unknown): string {
  // 저장 위치 오류는 params 로 문장을 고른다. 서버 문장은 영어다. 그래서 code 표보다 먼저 가른다.
  const storageBackendText = storageBackendErrorText(error);
  if (storageBackendText !== null) return storageBackendText;
  if (isHttpClientError(error) && error.code && operationErrors[error.code])
    return operationErrors[error.code]!;
  return error instanceof Error ? error.message : "운영 요청을 완료하지 못했습니다.";
}
